/* eslint-disable camelcase */
(() => {
  angular.module('app').component('clinicPatientCommonPatientRelatedTreatmentComponent', {
    templateUrl: require('./patientRelatedTreatment.component.html'),
    controller,
    controllerAs: 'vm',
    bindings: {
      relatedTreatments: '<',
    },
  });

  controller.$inject = ['$scope', '$state', '$uibModal', '$interval', '$filter'];

  function controller() {
    const vm = this;
    vm.searchTreatmentPlaceholder = App.localize('TypeTreatmentKeywordsPlaceholder');

    vm.elementId = `uncoveredTreatmentTree_${Math.floor(Math.random() * Date.now())}`;

    vm.hasPanelPatientSearchForAdvancedSecurityEnhancement = abp.setting.getBoolean(
      'Hms.Feature.PanelPatientSearchForAdvancedSecurityEnhancement'
    );

    vm.searchRelatedTreatment = searchRelatedTreatment;

    function init() {
      const flattenRelatedTreatments = _.uniqBy(
        _.flattenDeep(vm.relatedTreatments, (treatment) => treatment),
        'id'
      );

      const childTreatments = 
        _.filter(flattenRelatedTreatments, (treatment) => treatment.parentId !== null);

      _.each(childTreatments, (treatment) => {
        const parent = _.find(flattenRelatedTreatments, (t) => t.id === treatment.parentId);

        if (typeof parent.children === 'undefined') parent.children = [];
        parent.children.push(treatment);
      });

      vm.flattenRelatedTreatments = flattenRelatedTreatments;
    }

    function buildTree() {
      const element = $(`#${  vm.elementId}`);
      const ref = $.jstree.reference(element);
      if (ref) {
        ref.destroy();
      }

      const uncoveredNodeIcon = '<i class="fas fa-times text-danger"></i> ';
      const coveredNodeIcon = '<i class="fas fa-check text-navy"></i> ';
      function getNodeText(data) {
        if (data.isCovered) return coveredNodeIcon + data.displayName;
        return uncoveredNodeIcon + data.displayName;
      }

      const treatments = _.map(vm.flattenRelatedTreatments, (record) => ({
          id: record.id,
          parent: record.parentId ? record.parentId : '#',
          displayName: record.displayName,
          text: getNodeText(record),
          state: {
            opened: record.hasUncoveredChild,
          },
          a_attr: {
            title: record.displayName
          }
        }));

      element
        .jstree({
          core: {
            data: treatments,
          },
          types: {
            default: {
              icon: 'fas fa-folder tree-item-icon-color icon-lg',
            },
            file: {
              icon: 'fas fa-file tree-item-icon-color icon-lg',
            },
          },
          search: {
            fuzzy: false,
            show_only_matches: true,
            show_only_matches_children: true,
          },
          sort (itemA, itemB) {
            const nodeA = this.get_node(itemA);
            const nodeB = this.get_node(itemB);
            if (nodeB.original.id === -1) {
              return 1;
            }
            if (nodeA.children_d.length > 0 && nodeB.children_d.length === 0) {
              return -1;
            }

            return nodeB.original.displayName < nodeA.original.displayName ? 1 : -1;
          },
          plugins: ['types', 'search', 'sort'],
        })
        .bind('select_node.jstree', (_e, data) => {
          const {href} = data.node.a_attr;
          if (href !== '#') {
            window.open(href);
          }
        });
    }

    function searchRelatedTreatment() {
      const element = $(`#${  vm.elementId}`);
      element.jstree('search', _.trim(vm.filter));
    }

    $(document).ready(() => {
      $('.dd').nestable();
      buildTree();
    });

    init();
  }
})();
